import { render, staticRenderFns } from "./RegionThresholdConfigEdit.vue?vue&type=template&id=43586406&"
import script from "./RegionThresholdConfigEdit.vue?vue&type=script&lang=js&"
export * from "./RegionThresholdConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports